class ArticleService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getArticles(params) {
    return this.apiService.get('/api/v1/one/article', params);
  }

  createArticle(params) {
    return this.apiService.post('/api/v1/one/article', params);
  }

  updateArticle(params, id) {
    return this.apiService.put(`/api/v1/one/article/${id}`, params);
  }

  deleteArticles(params) {
    return this.apiService.delete('/api/v1/one/article', params);
  }
}

export default ArticleService;
